var plusIcon = '<i class="bicon-expandmenu" style="font-size:25px;position:relative;bottom:-2px;"></i>';
var timeoutID,
  addTimeoutID,
  obj = {};

jQuery_T4NT(document).ready(function($) {
  $('.input-ctl').find('span.xxplus').each(function(i,e){
    $(e).handlePlusBtn({
      __returnBack: __returnBack
    });
  });

  $('.input-ctl').find('span.xxminus').each(function(i,e){
    $(e).handleMinusBtn({
      __returnBack: __returnBack
    });
  });
  
  function __returnBack( __key, __tt, __value ){
    if( undefined != obj[__key] ){
      clearTimeout( obj[__key].timeout_id );
    }
    
    obj[__key].timeout_id = setTimeout(function(){
      __tt.addClass('not-added');
      if( __value == 0 ){
        __tt.find('.xxplus').html( plusIcon );
      }else{
        __tt.find('.xxplus').text( __value );
      }
    }, 5000);
  }
  // end cart
  
  // membership
if( /^\/cart/ig.test( window.location.pathname ) ){
  // CHECK FOR BITES ID
  $.post('https://app.bites.com.my/grocery/membership/info', {
      customer_id: $('input[name=customer_id]').val(),
      shop_domain: $('input[name=shop_domain]').val()
    }, function(result){
      if( result.status == 1 ){
        if( $('#CartBitesId').length == 1 ){
          $('#CartBitesId').val( result.bites_id );
        }
        if( $('#reachableContactNumber').length == 1 ){
          $('#reachableContactNumber').val( result.phone );
        }
     }
  });  
}

  if( /^\/account/ig.test( window.location.pathname ) ){
    localStorage.setItem('customer_name', $('#bites-customer-name').text().trim());
    localStorage.setItem('customer_email', $('#bites-customer-email').text().trim());
    localStorage.setItem('customer_phone', $('#bites-customer-phone').text().trim());
    localStorage.setItem('customer_zip', $('#bites-customer-zip').text().trim());
  }

  if( /^\/search/ig.test( window.location.pathname ) ){
    var searchKeyword = $('.h_search_ip').val().trim();
    if( searchKeyword.length > 0 ){
      $.getJSON("https://mobile.bites.com.my/log/search?keyword="+searchKeyword, function(resp){ });
    }
  }
  
  if( /^\/pages\/membership/ig.test( window.location.pathname ) ){
    $.post('https://app.bites.com.my/grocery/membership/info', $('#form_bites_id').serializeArray(), function(result){
      if( result.status == 1 ){
        if( $('#bites_id').length == 1 ){
          $('#bites_id').val( result.bites_id );
        }
      }
    });
  }
  
  $('#save_bites_id').click(function(){
    var __t = $(this);
    if( $('#bites_id').val() != '' ){
      __t.attr('disabled', 'disabled');
      __t.text('Updating...');
      $.post('https://app.bites.com.my/grocery/membership/id', $('#form_bites_id').serializeArray(), function(result){
        __t.text('Updated');
        setTimeout(function(){
          __t.text('Save');
          __t.removeAttr('disabled');
          geckoShopify.HideNotices();
        }, 4000);
        geckoShopify.CreatNotices(result.message);
      });
    }
  	return false;
  });
  // end membership
  
  $('#re-order-button').click(function(){
    if( confirm('This action will remove all existing cart items. Proceed?') ){
      // clear cart
      geckoShopify.CreatNotices('Clearing cart...');
      $.ajax({
        url: '/cart/clear.js',
        type: 'POST',
        data: {},
        dataType: 'json',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
        },
        success: function (data, status) {
          
          // adding cart items
          var items = [];
          $('#order-table > tbody tr').each(function(i,e){
            if( undefined != $(e).attr('data-vid') && $(e).attr('data-vid') != '' ){
              items.push({
                id: $(e).attr('data-vid'),
                quantity: $(e).children('td[data-label=Quantity]').text().trim()
              });
            }
          });

          $('.fail-msg').remove();
          geckoShopify.CreatNotices('Adding items to cart...');
          __iAddData();
          function __iAddData(){
            if( items.length > 0 ){
              var __item = items[0];
              __add_item( [__item], function(data){
                
                if( undefined != data.status ){
                  $('tr[data-vid='+__item.id+']').addClass('bg-danger');
                  $('tr[data-vid='+__item.id+']').after('<tr class="bg-danger"><td colspan="10"><small>'+data.description+'</small></td></tr>');
                }else{
                  $('tr[data-vid='+__item.id+']').addClass('bg-success');
                }
                
                items.splice(0,1);
                __iAddData();
                
              });
            }else{
              geckoShopify.CreatNotices('Done.');
              geckoShopify.onCartUpdate(1,1);
            }
          }

        },
        error: function (data) {
          console.log( data );
          if (data.status == 404) {
            alert('Error.');
          } else {
            console.log('Error: ' + data.message);
          }
        }
      });
    }
    
    return false;
  });

  var __timeoutId;

  var __bitesId = localStorage.getItem('bites_id');
  if( __bitesId != '' && __bitesId != null ){
     $('#CartBitesId').val( __bitesId );
  }

  $('#CartBitesId').keyup(function(){
    var ____val = $('#CartBitesId').val();
    ____val = ____val.replace( /[^0-9]/ig, '' );
    ____val = ____val.substr(0,8);
    $('#CartBitesId').val( ____val );

    clearTimeout(__timeoutId);
    __timeoutId = setTimeout(function(){
      if( ____val.length >= 8 ){
        $.ajax({
          url: '/cart/update.js',
          type: 'POST',
          data: JSON.stringify({
            attributes: {
              'Bites-Id': ____val
            }
          }),
          dataType: 'json',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
          },
          success: function (resp, status) {
            localStorage.setItem('bites_id', ____val);
          },
          error: function (data) {}
        });
      }
    }, 700);
  });

function __add_item( item, cb ){
   console.log('add', item);
    $.ajax({
      url: '/cart/add.js',
      type: 'POST',
      data: JSON.stringify({
        items: item
      }),
      dataType: 'json',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      success: function (data, status) {

//         // redirecting to checkout page
//         geckoShopify.CreatNotices('Checking out...');
//         window.location = '/cart';
        
        cb(data, status);
      },
      error: function (data) {
        cb(data.responseJSON);
//         if (data.status == 404) {
//           alert('Error.');
//         } else {
//           console.log('Error: ' + data.message);
//         }
      },
	  contentType: 'application/json'
    });
  }

  $('#brand-selector').children().each(function(i,e){
    $(e).click(function(){
      $('#brand-selector').children().find('span.brand-logo').removeClass('selected');
      $(e).find('span.brand-logo').addClass('selected');

      var __brand = $(e).attr('data-brand');
      if( __brand == 'vg' ){
        $('#vg-pickup-list').show();
        $('#big-pickup-list').hide();
      }else if( __brand == 'big' ){
        $('#vg-pickup-list').hide();
        $('#big-pickup-list').show();
      }
    });
  });

  if( $('#countryCallingCode').length == 1 ){
    $.getJSON("https://app.bites.com.my/etc/country_calling_code", function(resp){
      $('#countryCallingCode').empty();
      for(var i in resp){
        if( resp[i].code == 'MY' ){
          $('#countryCallingCode').append('<option selected="selected" value="'+resp[i].dial_code+'">'+resp[i].emoji+' '+resp[i].code+' '+resp[i].dial_code+'</option>');
        }else{
          $('#countryCallingCode').append('<option value="'+resp[i].dial_code+'">'+resp[i].emoji+' '+resp[i].code+' '+resp[i].dial_code+'</option>');
        }
      }
    });

    var __timeoutId2 = null;

    $('#reachableContactNumber').keyup(function(){
      var ____val = $('#reachableContactNumber').val();
      ____val = ____val.replace( /[^0-9]/ig, '' );
      ____val = ____val.trim();
      
      clearTimeout(__timeoutId2);
      __timeoutId2 = setTimeout(function(){
        if( ____val.length >= 8 ){
          ____val = $('#countryCallingCode').val()+____val;
          $.ajax({
            url: '/cart/update.js',
            type: 'POST',
            data: JSON.stringify({
              attributes: {
                'Whatsapp-Phone': ____val
              }
            }),
            dataType: 'json',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
            },
            success: function (resp, status) {},
            error: function (data) {}
          });
        }
      }, 700);
    });
  }

  
  if( $('#pr_recommendations').length > 0 ){
    var __t = $('#pr_recommendations');
    var __baseUrl = __t.attr('data-baseurl');
    var __id = __t.attr('data-id');
    var __limit = __t.attr('data-limit');
    var __type = __t.attr('data-type');
    
    $.get( __baseUrl+'?section_id=product-recommendations&product_id='+__id+'&limit='+__limit, function(section){
      var recommendationsMarkup = $(section).html();
      if (recommendationsMarkup.trim() !== '') {
        __t.html(recommendationsMarkup);

        __t.find('span.xxplus').each(function(i,e){
          $(e).handlePlusBtn({
            __returnBack: __returnBack
          });
        });
        
        __t.find('span.xxminus').each(function(i,e){
          $(e).handleMinusBtn({
            __returnBack: __returnBack
          });
        });
        
        var seat = __t.find('.pr_animated:not(.done)');
        geckoShopify.class_sequentially(seat);
        
        var $this = __t.find('.nt_products_holder');
        geckoShopify.refresh_flickity($this);
        geckoShopify.flickityResposition(false,$this);
        geckoShopify.InitCountdown();
        geckoShopify.review();
        geckoShopify.lazyWishUpdate();
      } else {
        __t.slideUp();
      }
    });
  }

    ///
    function updateLineItemProperties( data, done ){
      $.post('/cart/change.js', data, function(resp1, status, jqXHR){
        // console.log(resp1, status, jqXHR);
        done();
      }, 'json')
      .fail(function(a){
        var __data11 = { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ part:"updateLineItemProperties", error: a.responseText }) };
          fetch("https://app.bites.com.my/log/web/error", __data11);
  
        done();
      });
    }
    ///
    function __addMiscItem( variantId, qty, done ){
      if( qty == 0 ){
        return done(null);
      }
      
      let formData = {
        updates: {}
      };
      formData.updates[variantId] = qty;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      }).then(response => {
        return response.json();
      }).then(respo => {
        done( null, respo );
      }).catch((err) => {
        done( err );
        
        var __data11 = { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ part:"__addMiscItem", error: err.toString() }) };
        fetch("https://app.bites.com.my/log/web/error", __data11);
      });
    }
    ///
    function __continueCheckout(){
      var pr = {
        _bites: '',
        _addedOn: moment().format('YYYY-MM-DD HH:mm:ss')
      },
      __attr = {
        'Outlet-Id': window.outletId,
        'Checkout-Method': $('#checkout-method').val()
      };

      if( $('#CartBitesId').length > 0 ){
        if( $('#CartBitesId').val().trim() != '' ){
          __attr['Bites-Id'] = $('#CartBitesId').val().trim();
        }
      }
      
      if( $('#bites-slot-tab').find('.tab-nav-item.active').attr('data-target') == '#tab_delivery' ){
        $('#tab_delivery').siblings().find('input,select').attr('disabled', 'disabled');
        
        pr._bites = [
          window.outletId,
          'd',
          $('#delivery-postcode').val(),
          $('#delivery-date').val(),
          $('#delivery-time').val()
        ];
        
        __attr['Delivery-Postcode'] = $('#delivery-postcode').val();
        __attr['Collection-Date'] = $('#delivery-date').val();
        __attr['Collection-Time'] = $('#delivery-time').val();
      }else{
        $('#tab_pickup').siblings().find('input,select').attr('disabled', 'disabled');
        
        pr._bites = [
          window.outletId,
          'p',
          '',
          $('#pickup-date').val(),
          $('#pickup-time').val()
        ];
        
        __attr['Collection-Date'] = $('#pickup-date').val();
        __attr['Collection-Time'] = $('#pickup-time').val();
      }
      
      pr._bites = pr._bites.join('#');

      if( $('#d2d').length > 0 ){
        if( $('#d2d').is(':checked') ){
          pr._d2d = 1;
        }
      }

      $.post('/cart/update.js', {
        attributes: __attr
      }, function(resp0){

        var ___errors = [];
        try {
          if( undefined == resp0.attributes['Collection-Date'] ){
            ___errors.push('Failed to set Collection Date!');
          }
        } catch (error) {
          console.log('catch', error);
        }

        if( ___errors.length > 0 ){
          geckoShopify.CreatNotices(___errors.join(' '));
        }else{
          var xxData = {
            line: 1,
            properties: pr
          };
          updateLineItemProperties( xxData, () => {
            //----
            var totalPlasticBag = 0;
            var totalInsulatedBag = 0;
            //----
            var items = resp0.items;
            var tWeight = 0; // for other products
            var tWeight2 = 0; // for chilled,frozen
            var data = {
              updates: {}
            };
            
            try{
              data.updates[items[0].variant_id] = items[0].quantity;
            }catch(err){ console.log(err) }
            
            for(var i in items){
              var __gram = parseInt( items[i].grams );
              var __qty = parseInt( items[i].quantity );
              var __type = items[i].product_type.toLowerCase();
              console.log( '__gram', __gram );
              
              if( window.aProductTypeList.indexOf( __type ) != -1 ){
                if( __gram >= 2000 ){
                  totalInsulatedBag += __qty;
                }else{
                  tWeight2 += __gram * __qty;
                }
              }else{
                if( __gram >= 2000 ){
                  totalPlasticBag += __qty;
                }else{
                  tWeight += __gram * __qty;
                }
              }
            }
            
            totalPlasticBag += (tWeight > 0 && tWeight < 2000) ? 1 : Math.ceil( parseInt( tWeight ) / 2000 );
            totalInsulatedBag += (tWeight2 > 0 && tWeight2 < 1000) ? 1 : Math.ceil( parseInt( tWeight2 ) / 1000 );
  
            __addMiscItem( window.__misc.plastic.id, totalPlasticBag, () => {
              __addMiscItem( window.__misc.insulated.id, totalInsulatedBag, () => {
                $.post('/cart/update.js', data);
                setTimeout(() => {
                  window.location = '/checkout';
                }, 1000);
              });
            });
            
          });
        }
      }, 'json');
    }
    ///
    $('button.btn_checkout').off().on('click', function(){
      if( $('#tab_delivery').is(':visible') ){
        var __date = $('#delivery-date').val();
        var __time = $('#delivery-time').val().split('-')[0].trim();

        if( moment(`${__date} ${__time}`, `YYYY-MM-DD HH00`).isBefore( moment() ) ){
          geckoShopify.CreatNotices('Selected time slot has passed, please select a new slot.');
          $('#delivery-date, #delivery-time').val('');
          $('#delivery-time').attr('disabled', 'disabled').trigger('change');
          $('button.btn_checkout').attr('disabled', 'disabled');
          setTimeout(() => {
            geckoShopify.HideNotices();
          }, 2000);
          return false;
        }
      }

      if( $('#tab_pickup').is(':visible') ){
        var __date = $('#pickup-date').val();
        var __time = $('#pickup-time').val();

        if( moment(`${__date} ${__time}`, `YYYY-MM-DD HH00`).isBefore( moment() ) ){
          geckoShopify.CreatNotices('Selected time slot has passed, please select a new slot.');
          $('#pickup-date, #pickup-time').val('');
          $('#pickup-time').attr('disabled', 'disabled').trigger('change');
          $('button.btn_checkout').attr('disabled', 'disabled');
          setTimeout(() => {
            geckoShopify.HideNotices();
          }, 2000);
          return false;
        }
      }


      if( $('#reachableContactNumber').val().length == 0 ){
        geckoShopify.CreatNotices('Phone number is required!');
        $('#reachableContactNumber-container').find('.ws-message').addClass('active');
        $('#reachableContactNumber').addClass('active');
        setTimeout(() => {
          geckoShopify.HideNotices();
          $('#reachableContactNumber-container').find('.ws-message').removeClass('active').addClass('inactive');
          $('#reachableContactNumber').removeClass('active');
          setTimeout(() => {
            $('#reachableContactNumber-container').find('.ws-message').removeClass('inactive');
          }, 2000);
        }, 2000);
      }else{

        var showMagnificPopup = false;
        if( $('#CartBitesId').val().length == 0 ){
          showMagnificPopup = true;
          $('#popup-bites-id').show();
        }else{
          $('#popup-bites-id').hide();
        }

        if( $('#bites-slot-tab').find('.tab-pane.active').attr('id') == 'tab_delivery' ){
          if( !$('#d2d').is(':checked') ){
            showMagnificPopup = true;
            $('#popup-d2d2').show();
          }else{
            $('#popup-d2d2').hide();
          }
        }
        // $('#popup-d2d2').hide(); // force hide
        
        if( showMagnificPopup ){
          $.magnificPopup.open({
            items: {
              src: "#confirmation-popup .cpk-post-result",
            },
            type: "inline",
            closeOnBgClick: true,
            closeBtnInside: true,
            showCloseBtn: true
          });
        }else{
          __continueCheckout();
        }
      }
      return false;
    })
    ///
  
    $('#continue-checkout').click(function(){
      $(this).attr('disabled', 'disabled');
      __continueCheckout();
      return false;
    });
});

(function($){
  $.fn.handlePlusBtn = function(options){
    var __t = $(this);
    __t.click(function(){
      var __input = __t.siblings('.input-text');
      var __max = parseInt(__input.attr('max'));
      var __key = __t.parents('.variations_form').find('input[name=id]').val();
      var __formData = {};
      obj[__key] = {};
      
      __t.html( plusIcon );
      
      if( __max == 0 ){
          return false;
      }
      
      var __value = parseInt( __input.val() ) + 1;
      if( __value >= __max ){
        __value = __max;
  
        geckoShopify.CreatNotices('The maximum quantity allowed per order is {{max}} items.'.replace('{{max}}', __max));
        setTimeout(function(){
          geckoShopify.HideNotices();
        }, 2000);
      }
    
      if( !__t.siblings('span.xxminus').is(':visible') ){
        __t.parents('.input-ctl').removeClass('not-added');
        obj[__key].previous_value = __input.val();
      }
      
      __input.val(__value);
      
      clearTimeout( addTimeoutID );
      addTimeoutID = setTimeout(function(){
        if( __value > 0 && obj[__key].previous_value != __value ){
          __formData[__key] = __value;
  
          //////
          $.ajax({
              type: "POST",
              url: '/cart/update.js',
              data: JSON.stringify({
                updates: __formData
              }),
              processData: false,
              success: function(resp){
                geckoShopify.onCartUpdate(1,1,__key);

                options.__returnBack( __key, __t.parents('.input-ctl'), __value );
              },
              error: function(XMLHttpRequest, textStatus) {
                console.log( XMLHttpRequest, textStatus );
                geckoShopify.onError(XMLHttpRequest, textStatus);
              },
              dataType: 'json',
              contentType: 'application/json'
          });
          //////
          
        }
      }, 800);
      
      return false;
    });
    
    return __t;
  }

  $.fn.handleMinusBtn = function(options){
    var __t = $(this);
    __t.click(function(){
      var __input = __t.siblings('.input-text');
      var __value = parseInt( __input.val() );
      var __key = __t.parents('.variations_form').find('input[name=id]').val();
      var __formData = {};
      
      if( __value <= 0 ){
        __t.parents('.input-ctl').addClass('not-added');
      }else{
        __value -= 1;
        __input.val( __value );
  	      
        clearTimeout( addTimeoutID );
        addTimeoutID = setTimeout(function(){
          __formData[__key] = __value;
  
          $.post('/cart/update.js', {
            updates: __formData
          }, function(resp){
            geckoShopify.onCartUpdate(1,1,__key);
          }, 'json');
          
        }, 800);
        
        options.__returnBack( __key, __t.parents('.input-ctl'), __value );
      }
      return false;
    });
    
    return __t;
  }
})(jQuery_T4NT)